// extracted by mini-css-extract-plugin
module.exports = {"abrdn-list":"abrdn-list_abrdn-list__Pxwaj"};